exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/eod-recon/components/sales-eod-container/form-sales-eod/form-sales-category/form-sales-category.component.scss
// module id = ../../../../../src/app/views/daily-recon/eod-recon/components/sales-eod-container/form-sales-eod/form-sales-category/form-sales-category.component.scss
// module chunks = main